import { Component, OnInit, OnDestroy, Directive, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';

import { AppConstants } from 'appshared/app-constants';
import * as Models from 'appshared/shared-models';
import { MiscTools } from 'appshared/misc-tools';
import { UITools } from 'appshared/ui-tools';

import { ZenCustomersService } from '../zen-customers.service';
import { PagingSearchBarComponent } from 'client/app/components/shared/paging-search-bar/paging-search-bar.component';

@Component({
	selector: 'app-zen-customers-report-sources',
	templateUrl: './zen-customers-report-sources.component.html',
	styleUrls: ['./zen-customers-report-sources.component.scss']
})
export class ZenCustomersReportSourcesComponent implements OnInit {
	ac = AppConstants;
	mt = MiscTools;
	ut = UITools;

	@ViewChild(PagingSearchBarComponent) pagingSearchBar: PagingSearchBarComponent = null;

	items: Models.ZenMasterSource[] = [];
	itemsToShow: Models.ZenMasterSource[] = [];
	zenCustomers: Models.ZenMasterCustomer[] = [];

	loading = true;

	showFilters = false;
	theForm: UntypedFormGroup;

	searchTerm = '';

	displayOptions: Models.TableDisplayOptions = new Models.TableDisplayOptions();
	pagingOptions: Models.TablePagingOptions = new Models.TablePagingOptions();
	storageKey: string = 'WIPE-FILTER.cp-zen-sources-report';

	columnDefs: Models.ColumnDefinition[] = [
		{
			field: '__prefix',
			type: 'baseText',
			sortType: 'text',
			label: 'Site',
			toolTip: null,
			icon: null
		}, {
			field: 'name',
			type: 'baseText',
			sortType: 'text',
			label: 'Name',
			toolTip: null,
			icon: null
		}, {
			field: 'source_type',
			type: 'baseText',
			sortType: 'text',
			label: 'Source Type',
			toolTip: null,
			icon: null
		}
	];

	fieldsToShow: string[] = [];
	allFieldsToShow: string[] = [];
	lockedFields: string[] = [];
	baselineFields: string[] = [];
	minimalFields: string[] = [];


	constructor(
		private router: Router,
		private zenCustomersService: ZenCustomersService
	) { }

	ngOnInit(): void {
		const searchTerm = JSON.parse(localStorage.getItem('CLEAN.zenSources.searchTerm'));
		if (searchTerm) this.searchTerm = searchTerm;

		this.initForm();
		this.loadZenObjects();
	}

	async loadZenObjects(forceReload = false) {
		this.loading = true;
		this.zenCustomers = this.zenCustomersService.getAll();
		await this.filterZens();
	}

	initForm() {
		this.theForm = new UntypedFormGroup({
			searchTerm: new UntypedFormControl(this.searchTerm),
		});
	}

	async onFormChange() {
		// console.log(this.theForm.value.objTypes);
		// console.log(this.theForm.value);

		this.searchTerm = this.theForm.value.searchTerm;

		localStorage.setItem('CLEAN.zenSources.searchTerm', JSON.stringify(this.searchTerm));

		this.filterZens();
	}

	async filterZens() {
		this.loading = true;

		// this.zenClustersToShow = this.zenClusters.slice();

		this.items = [];

		if (this.searchTerm && this.searchTerm !== '') {
			this.items = await this.zenCustomersService.getSources(this.searchTerm);
			for (const item of this.items) {
				const idx = MiscTools.findIndexGeneric(this.zenCustomers, 'id', +item.customer_id);
				if (idx !== -1)
					item['__prefix'] = this.zenCustomers[idx].dns_prefix;
			} // for
		}

		this.fieldsToShow = [];
		this.allFieldsToShow = [];
		this.lockedFields = [];
		this.baselineFields = [];
		this.minimalFields = [];
		for (const cd of this.columnDefs)
			this.fieldsToShow.push(cd.field);

		this.loading = false;

		await MiscTools.delay(100);
		this.pagingSearchBar.setupPaging(this.items, this.columnDefs, this.storageKey, 'name', 'asc');

	}

	getSiteRoute(zenSource: Models.ZenMasterSource) {
		return ['/' + AppConstants.urls.zencustomers, zenSource.customer_id];
	}

	toggleFilters() {
		this.showFilters = !this.showFilters;
	}

	// ------------------------------------------------------------------------
	filterItems(matchWords: string[]): any[] {
		const tmpList: Models.ZenMasterSource[] = [];
		for (const item of this.items) {
			let match: boolean = true;
			if (matchWords.length > 0) {
				let matches: number = 0;
				for (const w of matchWords) {
					if ((item.name && item.name.toLowerCase().includes(w))
						|| (item.source_type && item.source_type.toLowerCase().includes(w))
						|| (item['prefix'] && item['prefix'].toLowerCase().includes(w))
					)
						matches++;
				} // for
				if (matches !== matchWords.length) match = false;
			} // if

			if (match) tmpList.push(item);
		} // for
		return tmpList;
	}

	// ------------------------------------------------------------------------
	setSortBy(field: string) {
		this.pagingSearchBar.setSortBy(field);
	} // setSortBy

	// ------------------------------------------------------------------------
	// Catch calls from the paging/search bar
	// ------------------------------------------------------------------------
	getParentMethod(): any {
		return {
			filterItems: (matchWords: string[]) => {
				return this.filterItems(matchWords);
			},
			updateItemsToShow: (itemsToShow: any[], displayOptions: Models.TableDisplayOptions, pagingOptions: Models.TablePagingOptions) => {
				this.itemsToShow = itemsToShow;
				this.displayOptions = displayOptions;
				this.pagingOptions = pagingOptions;
			},
			updateFieldsToShow: (fieldsToShow: string[]) => {
				this.fieldsToShow = fieldsToShow;
			},
			setPageNum: (pageNum: number, uniqueId: string) => {
				if (this.pagingSearchBar) this.pagingSearchBar.setPageNum(pageNum);
			},
			setSortBy: (field: string) => {
				this.setSortBy(field);
			}
		}
	}


}

